// Per-route document titles. GA reads document.title when it records a page
// view, and the SPA used to keep the static "Sign in" title on every screen,
// so all dashboard traffic showed up as the login page.

const TITLES: Record<string, string> = {
  "/": "Home",
  "/setup": "Setup",
  "/login": "Sign in",
  "/signup": "Sign up",
  "/claim": "Claim account",
  "/quickstart": "Quickstart",
  "/activity": "Activity",
  "/settings": "Settings",
  "/status": "Status",
  "/coins": "Coins",
  "/billing": "Billing",
  "/pages": "Pages",
  "/products": "Products",
  "/links": "Payment links",
  "/unlocks": "Unlocks",
  "/ads": "Ads",
  "/stats": "Stats",
  "/webhooks": "Webhooks",
  "/api-keys": "API keys",
};

export function titleFor(pathname: string): string {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const name = TITLES[path] ?? (path.startsWith("/activity/") ? "Payment detail" : null);
  return name ? `${name} · Shieldz Payments` : "Shieldz Payments";
}

export function applyTitle(pathname: string): void {
  document.title = titleFor(pathname);
}
